import type { Comment } from "./commentTypes";

export const addReplyRecursive = (
  comments: Comment[],
  parentId: string,
  reply: Comment
): Comment[] =>
  comments.map(c =>
    c.id === parentId
      ? { ...c, replies: [...c.replies, reply] }
      : { ...c, replies: addReplyRecursive(c.replies, parentId, reply) }
  );

export const updateCommentRecursive = (
  comments: Comment[],
  id: string,
  update: (c: Comment) => Comment
): Comment[] =>
  comments.map(c =>
    c.id === id
      ? update(c)
      : { ...c, replies: updateCommentRecursive(c.replies, id, update) }
  );

// Delete a comment (remove from array)
export const deleteCommentRecursive = (
  comments: Comment[],
  id: string
): Comment[] =>
  comments
    .filter(c => c.id !== id)
    .map(c => ({ ...c, replies: deleteCommentRecursive(c.replies, id) }));


// resources/js/src/components/community/comments/commentHelpers.ts

export const timeAgo = (dateString: string) => {
  const date = new Date(dateString);
  const now = new Date();
  const diff = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return date.toLocaleDateString();
};
